
export default function SearchBar({
  value,
  onChange,
}: {
  value: string;
  onChange: (val: string) => void;
}) {
  return (
    <div className="max-w-2xl mx-auto px-6 py-8">
      <div className="relative">
        <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center pointer-events-none">
          <i className="ri-search-line text-lg text-gray-400"></i>
        </div>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search questions... e.g. pricing, drift, deer, scheduling"
          className="w-full pl-12 pr-10 py-4 bg-white border border-gray-200 rounded-lg shadow-sm text-sm focus:ring-2 focus:ring-emerald-700 focus:border-transparent outline-none transition-shadow"
        />
        {value && (
          <button
            onClick={() => onChange('')}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        )}
      </div>
    </div>
  );
}
